import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router-dom';
import { submissionsApi } from '../../../utils'
import AssessmentTable from './AssessmentTable'
import { FilterExtention, Filter, FilterTypesEnum, Filters, FilterItem } from "../../UI/Filter";
import classes from './LearningTrackingAssessments.module.css'
import { throwApiError } from '../../lms-shared/store/error-handling-actions'
import { filteredAssessmentsAction } from '../../../store/filteredAssessments-slice';
import { SourceTypeTextEnum } from '../../../models/SourceTypeEnum';
import { ActivityTypeEnumText } from '../../../models/ActivityTypeEnum';

const LearningTrackingAssessments = () => {

    const texts = useSelector(state => state.translate.texts);
    const { id } = useParams();
    const { guid } = useParams();
    const [allAssessments, setAllAssessments] = useState([{ submissions: [] }, { submissions: [] }, { submissions: [] }])
    const [currentTab, setCurrentTab] = useState(0)
    const [filteredList, setFilteredList] = useState(0)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(filteredAssessmentsAction.setFilteredAssessments({ filteredAssessments: filteredList }));
    }, [filteredList]);

    useEffect(() => {
        if (id && texts && texts.assessmentsToCheck && guid != 0) {
            setAllAssessments([
                { submissions: [], numTab: 0, name: texts.assessmentsToCheck, comment: texts.assessmentsToCheck },
                { submissions: [], numTab: 0, name: texts.QuestionsFromStudents, comment: texts.QuestionsFromStudents },
                { submissions: [], numTab: 0, name: texts.CheckedAssignments, comment: null }
            ])

            const newallAssessments = [
                { submissions: [], numTab: 0, name: texts.assessmentsToCheck, comment: texts.assessmentsToCheck },
                { submissions: [], numTab: 0, name: texts.QuestionsFromStudents, comment: texts.QuestionsFromStudents },
                { submissions: [], numTab: 0, name: texts.CheckedAssignments, comment: null }
            ];

            const data = {
                studyGroupId: id,
                activityType: ActivityTypeEnumText.Final,
                sourceTypes: [SourceTypeTextEnum.IDE],
                allParticipants: true,
            };
            
            if (guid && guid !== "all") {
                data.toCId = guid;
            }
            submissionsApi.submissionsFilterRangePost({ submissionsRangeFilter: data }, (error, resdata, response) => {
                if (error) {
                    setAllAssessments(newallAssessments)
                    dispatch(throwApiError({ userMessage: texts.submissionsFilterError, error: error, statusCode: response?.statusCode, message: "submissionsFilterRangePost " + error.message, level: 1, component: "LearningTrackingAssessments", line: 41 }))
                }
                else {
                    // const sortStatus = { "Submitted": 1, "Resubmitted": 2, "Rejected": 3, "Started": 4, "NotStarted": 5, "Scored": 6, "Completed": 7 }
                    // setAssessments(resdata.sort((a, b) => sortStatus[a.submissionStatusId] - sortStatus[b.submissionStatusId]))

                    let AddLengthTabs = null
                    let currentIndex = null

                    resdata.map(d => {
                        if (d.submissionStatusId === "Resubmitted" || d.submissionStatusId === "Submitted" || d.submissionStatusId === "Rejected") {
                            currentIndex = 0
                            if (d.submissionStatusId !== "Rejected")
                                AddLengthTabs = 0
                        }
                        else
                            if (d.submissionStatusId === "NotStarted" || d.submissionStatusId === "Started") {
                                currentIndex = 1
                                if (d.pendingMessagesCount > 0)
                                    AddLengthTabs = 1
                            }
                            else
                                if (d.submissionStatusId === "Completed" || d.submissionStatusId === "Scored")
                                    currentIndex = 2

                        //    For filter;
                        d.submittedByUserFirstName = d.submittedByUser.firstName
                        newallAssessments[currentIndex].submissions.push(d)
                        if (AddLengthTabs !== null) {
                            newallAssessments[currentIndex].numTab = newallAssessments[currentIndex].numTab + 1
                            AddLengthTabs = null
                        }
                        d.assessmentContentData = JSON.parse(d.assessmentContentData)
                    })
                    setAllAssessments(newallAssessments)
                }
            })
        }
    }, [id, guid, texts]);

    return (
        <div className={classes.Assessments}>
            <div className={classes.Filter}>
                <FilterExtention list={allAssessments[currentTab].submissions} setFilteredListOutput={setFilteredList} >
                    <Filters>
                        <Filter name="free" text={texts.freeFilter} type={FilterTypesEnum.free}></Filter>
                        <Filter name="submittedByUserFirstName" text={texts.filterByStudent} type={FilterTypesEnum.values}></Filter>
                        <Filter name="assessmentName" text={texts.filterByAssessment} type={FilterTypesEnum.values}></Filter>
                        {/* <Filter name="submissionStatusId" text={texts.filterByStatus} type={FilterTypesEnum.values}></Filter> */}
                    </Filters>
                    <FilterItem>
                        <AssessmentTable allSubmissions={allAssessments} currentTab={currentTab} setCurrentTab={(numTab) => setCurrentTab(numTab)}></AssessmentTable>
                    </FilterItem>
                </FilterExtention>
            </div>
        </div>
    )
}

export default LearningTrackingAssessments;